<style scoped>
  .tab >>> .ivu-tabs-nav{line-height: 60px;margin-left:30px;}
  .tab >>>.ivu-tabs-tab{line-height: 60px;}
  .tab >>> .ivu-tabs-bar{margin-bottom: 0;}
  .notice-background{background: url("/img/sys/bg10.png");height: 140px;}
</style>
<template>
  <div>
    <Row>
      <Col span="24" class="notice-background"></Col>
    </Row>
    <Row class="tab" style="max-width: 1200px">
      <Col span="24" >
        <Tabs style="background-color: white;">
          <TabPane label="案件模板">
            <router-view></router-view>
          </TabPane>
        </Tabs>
      </Col>
    </Row>
  </div>
</template>

<script>
  export default {
    name: "mdPage",
  }
</script>

<style scoped>

</style>